export default {
  autoplayKakao: true,
  autoplayYoutube: false,
  playerWrapperId: 'vclipIframePlayer',
  playlistSelector: '.player_foot'
};


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/video-player/default-configs.js
 **/